import React from "react";

// ─── SAMPLE DATA (mirrors the JSON schema from the spec) ─────────────────────

const data = {
    course: {
        id: "course_202601",
        name: "Geometry for beginners",
        subject: "math"
    },
    assignment: {
        id: "assign_math_explain_456",
        type: "explanation",
        prompt: "Explain why the area of a triangle is half the area of a rectangle with the same base and height. Use diagrams or examples to support your reasoning."
    },
    rubrics: [
        {
            id: "rubric_20260115_0001",
            artifact_type: "written",
            content: "Response must explain how to skin a cat in at least 3 different ways.",
            expected_response: "Both should receive similar food because they are similar lengths/size",
        },
        {
            id: "rubric_20260115_0002",
            artifact_type: "video",
            content: "Student must demonstrate how to use a calculator to solve a problem.",
        }
    ],
    response: {
        id: "assess_20260115_0042",
        artifacts: [
            {
                id: "art_001",
                type: "written",
                format: "text/plain",
                content: "I think 5,238 is easier because thats how we write numbers in math class and I can see its five thousand right away.",
            },
            {
                id: "art_002",
                type: "video",
                format: "video/mp4",
                content: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            }
        ]
    },
    class: {
        id: "class_20250901",
        name: "Math 101",
        grade_level: "7",
        teacher: {
            id: "teacher_20250901_0001",
            name: "",
            email: "",
        },
    },
    student: {
        id: "STU-7291",
        name: "Peter Smith",
        grade_level: "7",
    },
    school: {
        id: "school_20250901",
        name: "Math School",
        district: {
            id: "district_20250901",
            name: "Math District",
            state: "CA",
            country: "USA"
        }
    },
    timestamp: "2026-01-15T10:45:00Z"
};
const data_plain = {
    course_id: "course_202601",
    course_name: "Geometry for beginners",
    course_subject: "math",
    assignment_id: "assign_math_explain_456",
    assignment_type: "explanation",
    assignment_prompt: "Explain why the area of a triangle is half the area of a rectangle with the same base and height. Use diagrams or examples to support your reasoning.",
    rubric_id: "rubric_20260115_0001",
    artifact_type: "written",
    rubric_content: "Response must explain how to skin a cat in at least 3 different ways.",
    rubric_expected_response: "Both should receive similar food because they are similar lengths/size",
    class_id: "class_20250901",
    class_name: "MRoom 12",
    class_grade_level: "7",
    teacher_id: "teacher_20250901_0001",
    teacher_name: "Ms. Jane Doe",
    teacher_email: "j_doe@example.com",
    student_id: "STU-7291",
    student_name: "Peter Smith",
    student_grade_level: "7",
    school_id: "school_20250901",
    school_name: "Math School",
    school_state: "CA",
    school_country: "USA",
    district_id: "district_20250901",
    district_name: "Math District",
    district_state: "CA",
    district_country: "USA",
    timestamp: "2026-01-15T10:45:00Z",
    artifact_id: "art_001",
    artifact_format: "text/plain",
    artifact_content: "I think 5,238 is easier because thats how we write numbers in math class and I can see its five thousand right away."
}

// ─── JSON VIEWER ──────────────────────────────────────────────────────────────

const JsonViewer = ({data, label}) => (
    <div style={{marginTop: "12px"}}>
        <div style={{
            fontSize: "11px", fontWeight: 700, color: "#6B7280", textTransform: "uppercase",
            letterSpacing: "0.8px", marginBottom: "8px",
        }}>{label}</div>
        <pre style={{
            background: "#111827", color: "#D1D5DB", padding: "20px",
            borderRadius: "10px", fontSize: "12px", lineHeight: 1.6,
            overflow: "auto", margin: 0,
            fontFamily: "'SF Mono', 'Fira Code', 'Cascadia Code', monospace",
        }}>
      {JSON.stringify(data, null, 2)}
    </pre>
    </div>
);

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

export default function MindsetsDashboard() {
    return (
        <div style={{
            fontFamily: "'Instrument Sans', 'DM Sans', 'Segoe UI', system-ui, sans-serif",
            background: "#F8F9FB", minHeight: "100vh", padding: "0",
        }}>
            {/* Header */}
            <div style={{
                background: "#111827",
                padding: "28px 32px 20px",
                borderBottom: "3px solid #2563EB",
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "4px"
                }}>
                    <div>
                        <div style={{
                            fontSize: "10px", fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase",
                            color: "#60A5FA", marginBottom: "6px",
                        }}>
                            Mindsets Intelligence Engine
                        </div>
                        <h1 style={{
                            margin: 0,
                            fontSize: "22px",
                            fontWeight: 700,
                            color: "#F9FAFB",
                            letterSpacing: "-0.3px"
                        }}>
                            Future-Ready Skills — API Input data structure
                        </h1>
                    </div>
                    <div style={{
                        padding: "4px 14px", borderRadius: "6px", border: "1px solid #374151",
                        fontSize: "11px", fontWeight: 600, color: "#9CA3AF",
                    }}>
                        MVP Phase 1 · 4 Skills
                    </div>
                </div>
                <p style={{margin: "8px 0 0", fontSize: "13px", color: "#9CA3AF", lineHeight: 1.5}}>
                    This is what partner platforms sends us.
                </p>
            </div>

            {/* Content */}
            <div style={{padding: "24px 32px"}}>
                <>
                    <JsonViewer data={data} label="Per-response (JSON)"/>
                </>
            </div>

            <div style={{padding: "24px 32px"}}>
                <>
                    <JsonViewer data={data_plain} label="Per-artifact (JSON)"/>
                </>
            </div>
        </div>
    );
}
